module.exports = __webpack_public_path__ + "media/checkout_application_v3/assets/images/flag_cs_czech-f7d5fa0258940e2c3ac9bb2c2ec57633.svg";